import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import Footer from "../components/footer";
import "./assessment-failed.css";

const AssessmentFailed = (props) => {
  return (
    <div className="assessment-failed-container1">
      <Helmet>
        <title>Assessment Result - Help Me Out</title>
        <meta property="og:title" content="Assessment Result - Help Me Out" />
        <link
          rel="canonical"
          href="https://www.helpmeout.co.za/assessment-failed"
        />
        <meta
          property="og:url"
          content="https://www.helpmeout.co.za/assessment-failed"
        />
      </Helmet>

      <div className="assessment-failed-container2">
        <div className="assessment-failed-icon-wrap">⚠</div>

        <h1>Assessment Completed</h1>

        <p className="assessment-failed-message">
          Unfortunately you do not meet our minimum requirements at this time.
          This doesn't mean you can't apply in the future — many applicants
          qualify after making a few adjustments.
        </p>

        <div className="assessment-failed-tips">
          <h3>What you can do next</h3>
          <ul>
            <li>Reduce existing debt obligations where possible</li>
            <li>Ensure all your accounts are active and in good standing</li>
            <li>Consider increasing your income stability before reapplying</li>
            <li>Check if debt review is still active and seek resolution</li>
          </ul>
        </div>

        <Link to="/" className="assessment-failed-navlink">
          Return Home
        </Link>
      </div>

      <Footer
        text={
          <Fragment>
            <span className="assessment-failed-text13">
              Authorized Financial Credit Provider
            </span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="assessment-failed-text14">
              Our Partner In Business Funding
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="assessment-failed-text15">
              Apply now for instant financial assistance.
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="assessment-failed-text16">
              Get financial support when you need it most with HelpMeOut.
            </span>
          </Fragment>
        }
        copyright={
          <Fragment>
            <span className="assessment-failed-text17">
              © {new Date().getFullYear()} HelpMeOut. All rights reserved.
            </span>
          </Fragment>
        }
        termsLink={
          <Fragment>
            <span className="assessment-failed-text18">Terms of Use</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span className="assessment-failed-text19">Cookies</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="assessment-failed-text20">Privacy Policy</span>
          </Fragment>
        }
        rootClassName="footerroot-class-name"
      />
    </div>
  );
};

export default AssessmentFailed;
